<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-故障查询-修改
    -->
  <el-dialog
    title="修改故障查询"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
       
          <el-form-item label="故障ID" >
        <el-input
          v-model="form.id"
     
          class="max-w200"
        ></el-input>
  
      </el-form-item>
   
      <el-form-item label="故障名称" prop="title">
        <el-input
          v-model="form.title"
          placeholder="请输入故障名称"
   
          show-word-limit
          class="max-w460"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="故障码" prop="fault_code">
        <el-input
          v-model="form.fault_code"
          placeholder="请输入故障码"
     
          class="max-w460"
        ></el-input>
      </el-form-item>

          <el-form-item label="诊断策略" prop="diagnostic_strategy">
        <el-input
          v-model="form.diagnostic_strategy"
          type="textarea"
          :rows="4"
          placeholder="请输入诊断策略"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>

              <el-form-item label="诊断地址" prop="diagnostic_address">
        <el-input
          v-model="form.diagnostic_address"
          type="textarea"
          :rows="4"
          placeholder="请输入诊断地址"
  
          show-word-limit
        ></el-input>
      </el-form-item>

      
      
       <el-form-item label="选择故障查询分类" prop="fault_inquiry_catalog_id">
          <el-select
            v-model="form.fault_inquiry_catalog_id"
            filterable
            placeholder="请选择故障查询分类"
            style="width: 100%"
            :loading="loadingFaultInquiryCatalogs"
          >
            <el-option
              v-for="faultInquiryCatalog in faultInquiryCatalogList"
              :key="faultInquiryCatalog.fault_inquiry_catalog_id"
              :label="faultInquiryCatalog.name"
              :value="faultInquiryCatalog.fault_inquiry_catalog_id"
            >
            </el-option>
          </el-select>
        </el-form-item>


      
      <el-form-item label="排序值" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="999"
          controls-position="right"
          class="max-w200"
        ></el-input-number>
        <span class="ml-10 text-gray">值越小越靠前，默认50</span>
      </el-form-item>



    <!-- 图片上传 -->
    <el-card class="box-card mb-20" shadow="never">
      <div slot="header">
        <span>图片管理</span>
      </div>
      
  <el-form-item label="故障查询图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


    </el-card>

      <div slot="header">
        <span>详细内容</span>
      </div>
      
      <el-form-item label="故障描述" prop="intro">
        <Uediter
          v-model="form.intro"
          :config="ueditor.config"
          ref="ue"
        ></Uediter>
      </el-form-item>
      

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Fault_inquiryApi from "@/api/fault_inquiry.js";
import Fault_inquiry_catalogApi from "@/api/fault_inquiry_catalog.js";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      loadingFaultInquiryCatalogs: false,
      faultInquiryCatalogList: [],
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        fault_inquiry_catalog_id: "",
        name: "",
        code: "custom",
        // categorya:{
        //   name:""
        // },
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      /*验证规则*/
      rules: {
        title: [
          { required: true, message: "请输入故障查询标题", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.addFaultInquiryCatalogList();
  },
  props: ["open_add", "fault_inquiry_id"],
  methods: {
    addFaultInquiryCatalogList() {
      var self = this;
      Fault_inquiry_catalogApi.listx({}, true)
        .then(data => {
          self.loading = false;
          self.faultInquiryCatalogList = data.data;
        })
        .catch(error => {});
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Fault_inquiryApi.detail({ fault_inquiry_id: self.fault_inquiry_id }, true)
        .then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
     
      form.fault_inquiry_id = self.fault_inquiry_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Fault_inquiryApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}


.max-w460 {
  max-width: 460px;
}
.max-w200 {
  max-width: 200px;
}
.mb-20 {
  margin-bottom: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.text-gray {
  color: #999;
}

.upload-container {
  display: flex;
  flex-direction: column;
}
.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.draggable-list {
  display: flex;
  flex-wrap: wrap;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
}
.image-item {
  margin-right: 10px;
  margin-bottom: 10px;
}
.item {
  width: 120px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item img {
  max-width: 100%;
  max-height: 100%;
}
.item-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
}
.item:hover .item-actions {
  display: flex;
}
.item-actions a {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.img-select {
  cursor: pointer;
  color: #8c939d;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.img-select-tip {
  font-size: 12px;
  margin-top: 8px;
}

.form-actions {
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/fault_inquiry/index/part/edit.vue